import r from"styled-components";import{theme as t}from"../../../theme.js";const i=r.div`
  height: ${({variant:o})=>o==="horizontal"?"1px":"100%"};
  width: ${({variant:o})=>o==="horizontal"?"100%":"1px"};
  background-color: ${t.colors.gray[200]};
`;export{i as Container};
